import { createFileRoute } from "@tanstack/react-router";
import HowItWorks from "@/pages/site/HowItWorks";

export const Route = createFileRoute("/how-it-works")({
  component: () => <HowItWorks />,
});
